export type Catalog = Record<string, Record<string, string>>;

export type CatalogResponse = {
	locale: string;
	catalog: Catalog;
	version: string;
};

export const catalogToResources = (
	locale: string,
	catalog: Catalog,
): Record<string, Record<string, Catalog[string]>> => ({
	[locale]: { ...catalog },
});
